export const STAFF_ROLES = 'STAFF_ROLES';
export const BUILDING_FIELD = 'BUILDING_FIELD';
export const MASTER_PM_FIELD = 'MASTER_PM_FIELD';
export const DOORS_AND_CAMERAS = 'DOORS_AND_CAMERAS';
export const AMENITY_NOTES = 'AMENITY_NOTES';
export const AMENITY_ACTIVE = 'AMENITY_ACTIVE';
export const FREEZED_BUILDING = 'FREEZED_BUILDING';
export const LINK_DISPLAY_NAME = 'LINK_DISPLAY_NAME';

export const getInfoTypes = (t) => ({
  STAFF_ROLES: {
    url: 'https://carsonhelp.zendesk.com/hc/en-us/articles/360004979951-Staff-User-Access-Levels',
    title: t('tooltip.staffRoles'),
  },
  BUILDING_FIELD: {
    url: null,
    title: t('tooltip.building'),
  },
  MASTER_PM_FIELD: {
    url: null,
    title: t('tooltip.masterPm'),
  },
  DOORS_AND_CAMERAS: {
    url: null,
    title: t('tooltip.doorsAndCameras'),
  },
  AMENITY_NOTES: {
    url: null,
    title: t('tooltip.amenity'),
  },
  AMENITY_ACTIVE: {
    url: null,
    title: t('tooltip.amenityActive'),
  },
  FREEZED_BUILDING: {
    url: null,
    title: t('tooltip.freezedBuilding'),
  },
  LINK_DISPLAY_NAME: {
    url: null,
    title: t('tooltip.linkDisplayName'),
  },
});
